import axios from "axios";
import DOMPurify from "dompurify";

const getInitializedApiInstance = () => {
  return axios.create({
    // set up default config here.  See axios request config docs for options
    transformResponse: [
      function(html) {
        const cleanHTML = DOMPurify.sanitize(html);
        return cleanHTML;
      }
    ]
  });
};

// Helper functions
const get = (url: string) => {
  return getInitializedApiInstance().get(url);
};

// Public functions
export const getFooterHtml = (url: string) => {
  return get(url);
};

export const getWCMHtml = (url: string) => {
  return get(url);
};

export const getWCMJson = async (url: string) => {
  const result = await axios.get(url);
  return result.data;
};